<template>
  <div class="bg">
    <div class="content">
      <div class="container">
        <div class="title">
          <div class="title-CN">最新赛事</div>
          <div class="title-EN">Popular Events</div>
        </div>
        <div class="date">
          <div class="total-match">本月共计{{matchList.length}}场比赛</div>
          <div class="month-picker">
            <a-month-picker placeholder="请选择月份" :allowClear="true" mode="month" :default-value="moment(defaultMonth, monthFormat)" :format="monthFormat" @change="onChange" />
          </div>
          <div class="search">
            <input class="search-input" type="text" placeholder="请输入赛事名称搜索" v-model="searchVal">
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" @click="search()">
          </div>
        </div>
        <div class="border"></div>
        <div class="match">
          <div class="match-list" v-for="(match,index) in matchList" :key="index" @click="matchClick(match.id)">
            <div class="color-line"></div>
            <div class="time-add">
              <div class="match-time">
                <div class="time-num">{{match.beginTime.slice(8,10)}}</div>
                <div class="time-han">日</div>
              </div>
              <div class="match-fuhao">/</div>
              <div class="match-add">{{match.address}}</div>
            </div>
            <div class="square"></div>
            <div class="match-name">{{match.title}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  components: {},
  data () {
    return {
      info: {},
      player: [],
      defaultMonth: null,
      monthFormat: 'YYYY-MM',
      total: 50,
      params: {
        pageSize: 10,
        pageNum: 1,
        agencyId: -1,
        matchName: -1,
        time: '2021-12'
      },
      searchVal: null,
      searchTime: null,
      matchList: [],
      programId: this.$route.programId
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.setDefaultMonth()
    this.loadData()
  },
  methods: {
    moment,
    pageChange (e) {
      // this.params.pageNum = e
      // this.loadData()
    },
    matchClick (id) {
      // store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
      this.$router.push({name: 'MatchDetail', query: {matchId: id, programId: this.programId}})
    },
    setDefaultMonth () {
      let date = new Date()
      let year = date.getFullYear()
      let mm = date.getMonth() + 1
      let month = null
      if (mm < 10) {
        month = '0' + mm
      }
      this.defaultMonth = year + '-' + month
      this.searchTime = this.defaultMonth
      console.log('defaultMonth', this.defaultMonth)
    },
    loadData () {
      let params = {
        time: this.searchTime,
        matchName: this.searchVal,
        programId: this.$route.query.programId
      }
      this.$api.match.getEventMatch(params).then(res => {
        if (res.status == 0) {
          this.matchList = res.data
          // for (let i = 0; i < 11; i++) {
          //   this.matchList = this.matchList.concat(res.data)
          // }
        }
      }).catch(err => {
        console.log('err', err)
      })
    },
    onChange (val, dateStr) {
      this.searchTime = dateStr
      this.loadData()
    },
    search () {
      if (this.searchVal !== '' && this.searchVal !== null && this.searchVal !== undefined) {
        this.loadData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  background-color: #FFF;
}
.content {
  width: 100%;
  // height: 900px;
  // background-image: url(../../../assets/newMatchBg.png);
  // background: green;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  color: #333;
  padding: 85px 0 90px 0;
}
.container{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.title{
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 47px;
}
.title-CN{
  font-size: 30px;
  margin-right: 10px;
  font-weight: bold ;
}
.title-EN{
  font-size: 20px;
}
.border{
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
}
.date{
  width: 100%;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #999;
  font-size: 14px;
  // border-bottom: 1px solid #b3b3b3;
  margin-bottom: 48px;
}
.total-match{
  flex: 1;
  text-align: left;
}
.month-picker{
  flex: 1;
  text-align: center;
}
.search{
  flex: 1;
  border-bottom: 1px solid #b3b3b3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.search-input{
  width: 271px;
  padding-left: 50px;
  border: 0px;
  outline: none;
  margin-right: 95px;
}
.search-icon{
  width: 17px;
  height: 17px;
}
.match{
  width: 100%;
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  // background: #999;
}
.match-list{
  width: 48%;
  display: flex;
  align-content: center;
  margin-bottom: 20px;
  // background: green;
  // padding: 10px 0;
  // box-sizing: content-box;
  background: linear-gradient(to right, #FFF, #F9F9F9);
}
.color-line{
  width: 3px;
  // height: 100px;
  background-color: green;
}
.time-add{
  width: 50px;
  // height: 60px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-color: green;
}

.match-time{
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  // background: yellow;
}
.time-num{
  font-size: 20px;
   font-weight: bold;
}
.time-han{
  font-size: 8px;
  font-weight: bold;
}
.match-fuhao{
  width: 100%;
  height: 10px;
  font-size: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  // background: green;
}
.match-add{
  width: 100%;
  height: 20px;
  font-size: 11px;
  color: #000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  // background:grey;
}
.match-name{
  width: calc( 100% - 73px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  font-size: 17px;
  color: #333;
}
.square {
  z-index: 3;
  width: 0;
  height: 0;
  // border-color: transparent white;
  border-color: transparent transparent;
  // border-width:  50px 20px 0 0;
    border-width:  70px 20px 0 0;
  border-style: solid;
}
.match-list:hover{
  // padding: 10px 0;
  .time-add{
    background-color: green;
    color: #FFF;
  }
  .match-name{
    background-color: #E5E5E5;
    font-weight: bold;
  }
  .square{
    background-color: green;
    border-color: transparent #E5E5E5;
  }
  .match-add{
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/home/NewestMatch.vue